<h2 mat-dialog-title>{{ params.formData.title }}</h2>

<mat-dialog-content class="dialog-content">
  <div [innerHtml]="params.formData.content | markdown" class="dialog-content"></div>

  <div class="dialog-content flex-column">
    <mat-checkbox [disabled]="true" [checked]="true" color="primary">
      {{ params.formData.includeCv }}
    </mat-checkbox>
    <mat-checkbox [checked]="appendSkillSet" (change)="updateSkillSet($event.checked)" color="primary">
      {{ params.formData.appendSkillSetLabel }}
    </mat-checkbox>
    <mat-checkbox [checked]="appendProjectList" (change)="updateProjectList($event.checked)" color="primary">
      {{ params.formData.appendProjectListLabel }}
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <a mat-stroked-button href="{{ calculatedUrl }}" target="_blank" [mat-dialog-close]="true">
    {{ params.formData.okButtonLabel }}
  </a>
  <button mat-stroked-button mat-dialog-close>{{ params.formData.cancelButtonLabel }}</button>
</mat-dialog-actions>
